// Trio Soul Food — official menu (regular service)
// Source: in-house printed menu, transcribed verbatim.
// Entrees include 2 sides with choice of roll or cornbread.

export const MENU = [
  {
    category: "Appetizers",
    blurb: "Start with something hot. Plates made for the table to share.",
    items: [
      { name: "Mozz Sticks", price: "$5.25", desc: "Crispy golden mozzarella, marinara on the side." },
      { name: "Fried Gizzards", price: "$6.25", desc: "Seasoned and fried 'til crisp." },
      { name: "Loaded Chicken Chunks", price: "$7", desc: "Hand-breaded chicken bites, loaded the way you like." },
      { name: "Honey Glazed Okra", price: "$5.25", desc: "Cornmeal-fried okra, finished with hot honey." },
      { name: "Soul Food Eggrolls", price: "$7", desc: "House-made — Southern fillings, crispy wrapper." },
    ],
  },
  {
    category: "Entrees",
    blurb: "$16 each. Includes 2 sides with choice of roll or cornbread.",
    items: [
      { name: "Party Wings (8pc)", price: "$16", desc: "Eight wings, your favorite seasoning." },
      { name: "Fried Catfish", price: "$16", desc: "Cornmeal-crusted. Cajun available on request." },
      { name: "Fried Tilapia", price: "$16", desc: "Light, flaky, seasoned and fried to order." },
      { name: "Fried Chicken (2pc)", price: "$16", desc: "Two pieces, cast-iron fried, juicy and crisp." },
      { name: "Southern Chicken Fried Chicken", price: "$16", desc: "Buttermilk deep-fried breast on top of mashed potatoes & topped with white gravy." },
      { name: "Blackened Chipotle Grilled Chicken", price: "$16", desc: "Spiced and seasoned chicken breast grilled to perfection." },
      { name: "Blackened Salmon", price: "$26", desc: "Grilled & seasoned to perfection. (+$10 surcharge)" },
      { name: "Rasta Pasta", price: "$16", desc: "Creamy Caribbean-spiced pasta. Choose shrimp or chicken." },
      { name: "Blackened Chicken Parmesan Alfredo", price: "$16", desc: "Blackened chicken over parmesan alfredo. Also available with shrimp." },
      { name: "Fried Shrimp (8pc)", price: "$16", desc: "Eight crispy fried shrimp, golden and seasoned." },
      { name: "Blackened Grilled Chipotle Shrimp", price: "$16", desc: "Smoky chipotle-grilled gulf shrimp." },
      { name: "Lollipop Lamb Chops", price: "$31", desc: "Hand-cut lamb chops, French-trimmed, grilled. (+$15 surcharge)" },
    ],
  },
  {
    category: "Sides",
    blurb: "$5.25 each. Don't sleep on the sides — half the meal lives here.",
    items: [
      { name: "Collard Greens", price: "$5.25", desc: "Slow-simmered with smoked turkey." },
      { name: "Mashed Potatoes", price: "$5.25", desc: "Garlic parmesan flavored, whipped creamy." },
      { name: "Green Beans", price: "$5.25", desc: "Tender, seasoned, just the way grandma did." },
      { name: "Mac and Cheese", price: "$5.25", desc: "Cheesy, baked, golden top." },
      { name: "Candied Yams", price: "$5.25", desc: "Brown sugar, cinnamon, butter." },
      { name: "French Fries", price: "$5.25", desc: "Crispy, salted hot." },
      { name: "Fried Okra", price: "$5.25", desc: "Cornmeal-dusted, flash fried, sea salt." },
      { name: "Onion Rings", price: "$5.25", desc: "Beer-battered, golden and crunchy." },
      { name: "Asparagus", price: "$5.25", desc: "Grilled and seasoned." },
      { name: "Yellow Rice", price: "$5.25", desc: "Fluffy, seasoned yellow rice." },
    ],
  },
  {
    category: "Desserts",
    blurb: "Save room. We mean it.",
    items: [
      { name: "Sweet Potato Cheesecake", price: "$7", desc: "House sweet potato cheesecake — the South meets New York." },
      { name: "Fried Pies (Apple & Peach)", price: "$3", desc: "Hand-pies fried golden. Apple or peach." },
      { name: "Triple Chocolate Cake", price: "$7", desc: "Three layers of rich chocolate." },
    ],
  },
  {
    category: "Drinks",
    blurb: "Alabama classics and hand-shaken favorites.",
    items: [
      { name: "Coke", price: "", desc: "Ice cold." },
      { name: "Sprite", price: "", desc: "Crisp and clean." },
      { name: "Milo's Sweet Tea", price: "", desc: "Alabama's own. Poured over ice." },
      { name: "Strawberry Lemonade", price: "", desc: "Hand-shaken with fresh strawberries." },
    ],
  },
];

// Important footer note from the printed menu
export const MENU_NOTES = [
  "Items cooked to order. Consuming raw or undercooked meat, poultry, seafood, shellfish or eggs may increase the risk of food-borne illness, especially if you have certain medical conditions.",
  "Please make us aware of any food allergies or dietary requirements — we'll do our best to accommodate.",
  "*Dishes may contain nuts.",
];
